import { Category, NavigationItemType, Report } from 'core/slices/models';

/**
 * Check if a category is active based on the active report
 * @param category
 * @param activeReport
 */
export const isCategoryActive = (category: Category, activeReport: Report) => {
  if (!activeReport) return false;
  if (category && category.nodeType === NavigationItemType.CATEGORY) {
    return category.children?.some(
      child =>
        child.nodeType === NavigationItemType.REPORT &&
        child.id === activeReport.id
    );
  }
  return false;
};
